
@if (isVisible) {
  <div>
    @if (showloader) {
      <div class="loading" >
        <div class="loading_txt">
          <div class="load_txt">{{"returnsUK.loadinglabel" | cxTranslate}}</div>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    }
    @if (showLocationSelection) {
      <div class="col-xs-12 col-md-12 col-lg-12 no-padding UkCreateReturn">
        <section class="col-md-12 no-padding newReturnText" >
          <div class="col-md-6 newReturns_subheader">
            {{"returnsUK.newreturn" | cxTranslate}}
          </div>
        </section>
        <section class="col-xs-12 ReturnSelectLocation" id="newReturn_selectlocation" >
          <div class="newReturn_selectparent " id="newReturn_selectlocation-1" >
            <div class="newReturn_selectbox">
              <div class="col-xs-12 col-md-8 no-padding newReturn_selectheader" [innerHTML]="'returnsUK.locationsmsg' | cxTranslate"></div>
              <div class="col-xs-12 col-md-4 no-padding newReturn_selectcount">Return to: <span class="newReturn_loccount">{{ selectedCount }}</span>&nbsp;<span>location(s)</span></div>
              <div class="col-xs-12 cart_selectline"></div>
              <div class="clearboth"></div>
              <div class="col-xs-12 newreturn_selectoptions">
                <div class="newReturn_customsearch">
                  <i class="global_searchicon"></i><input type="search" placeholder="Search for location" id="newreturn_searchbox" (keyup)="applyFilter($event)"><button (click)="applyFilter($event)">Search</button>
                </div>
                <div class="newReturn_selectunselect">
                  <div class="newReturn_selectoption" id="newReturn_selectall" (click)="selectAll()">Select All</div><div class="newReturn_selectdivision"></div><div class="newReturn_selectoption" id="newReturn_clearall" (click)="clearAll()">Clear Selections</div>
                </div>
              </div>
              <div class="table-container">
                <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                  <!-- Checkbox Column -->
                  <ng-container matColumnDef="checked">
                    <th mat-header-cell *matHeaderCellDef>
                      <mat-checkbox (change)="toggleAllRows($event)"></mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let element"  >
                      @if (element.checked === 'false') {
                        <span class="return_unavbl">{{"returnsUK.returnunavailable" | cxTranslate}}</span>
                      }
                      @if (element.checked === 'true') {
                        <span></span>
                      }
                      @if (element.checked === 'myReturn') {
                        <span (click)="navigateToReturns($event, element)" class="return_link">{{"returnsUK.seereturntxt" | cxTranslate}}</span>
                      }
                    </td>
                  </ng-container>
                  <!-- Location Name Column -->
                  <ng-container matColumnDef="locname">
                    <td mat-cell *matCellDef="let element"> {{element.locname}} </td>
                  </ng-container>
                  <!-- Address Column -->
                  <ng-container matColumnDef="address">
                    <td mat-cell *matCellDef="let element"> {{element.address}} </td>
                  </ng-container>
                  <!-- State Column -->
                  <ng-container matColumnDef="state">
                    <td mat-cell *matCellDef="let element"> {{element.state}} </td>
                  </ng-container>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClick(row)" [ngClass]="{
                  'non_selectable': row.checked === 'false',
                  'selected-row': selection.isSelected(row),
                  'non_selectable_return': row.checked === 'myReturn'
                }"></tr>
                </table>
              </div>
              @if (dataSource.filteredData.length === 0) {
                <div class="norecord">
                  {{"returnsUK.norecordsmsg" | cxTranslate}}
                </div>
              }
            </div>
            <div class="newReturn_startorderbtnsection">
              <a class="newReturn_exitBtn returnPopupshow" (click)="openExistpopup()">{{"returnsUK.exitlabel" | cxTranslate}}</a>
              <button type="submit" class="newReturn_startorderbtn" id="toproductpage" [disabled]="selectedCount === 0" (click)="getProductsToReturn()">{{"returnsUK.selectprodtxt" | cxTranslate}}</button>
            </div>
          </div>
        </section>
      </div>
    }
    @if (showProductReturn) {
      <div class="col-xs-12 UkCreateReturn" id="newReturnProduct" >
        <section class="col-md-12 no-padding newReturnText" >
          <div class="col-md-6 newReturns_subheader">
            {{"returnsUK.newreturn" | cxTranslate}}
          </div>
        </section>
        <div class="productbox" >
          <div class="backtolocation"  (click)="backTolocation()">
            <div class="global_blackarrow"></div>
          {{"returnsUK.backtoloctxt" | cxTranslate}}</div>
          <!-- we can repeat from here -->
          <div class="greyline"></div>
          @for (returnData of productsToReturn; track returnData; let i = $index) {
            <div class="specificlocation">
              @for (shipData of returnData.returnsProductData.shipData; track shipData) {
                <div>
                  <div class="newReturn_productheader">{{"returnsUK.prodtoreturn" | cxTranslate}}</div>
                  <div class="newReturn_location">{{ returnData.shippingdata.locname }}</div>
                  <div class="row productrow" >
                    <div class="col-xs-4 no-padding locationdetail">
                      <div class="col-xs-11 no-padding newReturn_locationdetails" >
                        {{ shipData.addressLine1 }},
                        {{ shipData.town }}<br>
                      {{ shipData.postalCode }}</div>
                    </div>
                    <div class="custom_Product_Container">
                      @for (productName of getGroupedProductKeys(shipData.groupedProducts); track productName) {
                        <div class="col-xs-3 no-padding custom-product">
                          <!--For AQIV Product-->
                          @if (productName === 'aQIV' || productName === 'aTIV') {
                            <div class="col-xs-12 no-padding Returnaqivbox">
                              <div class="productname">{{ productName}}</div>
                              <div class="year">{{"returnsUK.65yeartxt" | cxTranslate}}</div>
                              <div class="enterdosestext">{{"returnsUK.enterdosestxt" | cxTranslate}}</div>
                              <!--total Remaining doses-->
                              <table class="Returntotalbox">
                                <tbody>
                                  <tr class="totalrow">
                                    <td>{{"returnsUK.totalaqiv" | cxTranslate}}</td>
                                    <td class="returnparent"><input type="text" class="totalReturn form-control blanktotalvalue"
                                      [value]="calculateTotalDoses(shipData.groupedProducts[productName], productName,shipData.productData.totalQuantity,shipData)"
                                      readonly="">
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <!--Product and batch details-->
                              <table class="prodcutbatch aqivreturn">
                                <tbody>
                                  <tr class="borderB10">
                                    <th>{{"returnsUK.batchnolabel" | cxTranslate}}</th>
                                    <th>{{"returnsUK.dosetoreturnlabel" | cxTranslate}}</th>
                                  </tr>
                                  @for (product of shipData.groupedProducts[productName]; track product) {
                                    <tr>
                                      <td>{{ product.batchNumber }}</td>
                                      <td class="aqivReturninput returnparent"><input type="text" (input)="handleInputChange(shipData, productName, product.inputValueaQiv)" autocomplete="no" class="dynbatch form-control returninput" [ngClass]="product.errMsg2?'redhighlight':''" [(ngModel)]="product.inputValueaQiv" (ngModelChange)="formatNumber($event, product, shipData.aqivMaxAllowedQty)" (keypress)="restrictInput($event)" id="" name=""></td>
                                    </tr>
                                  }
                                  <tr class="rowgap"></tr>
                                </tbody>
                              </table>
                              <!--remaining credit  doses and Error message-->
                              <table class="Return_Credit_Doses Returntotalbox_ErrorMsg">
                                <tbody>
                                  <tr class="total_Credit_Doses">
                                    <td>{{"returnsUK.totalativcredittxt" | cxTranslate}}</td>
                                    <td class="returnparent"><input type="text" class="totalReturn form-control blanktotalvalue"
                                      [value]="computeCreditTotalDoses(shipData.groupedProducts[productName], productName, shipData)"
                                      readonly="">
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <div class="clearboth"></div>
                            </div>
                          }
                          @if (productName === 'QIVc' || productName === 'TIVc') {
                            <div class="col-xs-12 no-padding Returnqivcbox">
                              <div class="productname">{{productName}}</div>
                              <div class="year">{{"returnsUK.6monthtxt" | cxTranslate}}</div>
                              <div class="enterdosestext">{{"returnsUK.enterdosestxt" | cxTranslate}}</div>
                              <!--total remaing doses-->
                              <table class="Returntotalbox">
                                <tbody>
                                  <tr class="totalrow">
                                    <td>{{"returnsUK.totalqivc" | cxTranslate}}</td>
                                    <td class="returnparent"> <input type="text" class="totalReturn form-control blanktotalvalue"
                                      [value]="calculateTotalDoses(shipData.groupedProducts[productName], productName,shipData.productData.totalQuantity,shipData)"
                                    readonly=""> </td>
                                  </tr>
                                </tbody>
                              </table>
                              <!--Product and batch details-->
                              <table class="prodcutbatch qivcreturn">
                                <tbody>
                                  <tr class="borderB10">
                                    <th>{{"returnsUK.batchnolabel" | cxTranslate}}</th>
                                    <th>{{"returnsUK.dosetoreturnlabel" | cxTranslate}}</th>
                                  </tr>
                                  @for (product of shipData.groupedProducts[productName]; track product) {
                                    <tr>
                                      <td>{{ product.batchNumber }}</td>
                                      <td class="QIVcReturninput returnparent"> <input type="text" autocomplete="no" class="dynbatch form-control returninput" [(ngModel)]="product.inputValueQivc" (ngModelChange)="formatNumber1($event, product, shipData.qivcMaxAllowedQty)" [ngClass]="product.errMsg2qivc?'redhighlight':''" (input)="handleInputChange(shipData, productName, product.inputValueQivc)" (keypress)="restrictInput($event)"> </td>
                                    </tr>
                                  }
                                  <tr class="rowgap"></tr>
                                </tbody>
                              </table>
                              <!--Remaing credit doses and error message code-->
                              <table class="Return_Credit_Doses Returntotalbox_ErrorMsg">
                                <tbody>
                                  <tr class="total_Credit_Doses">
                                    <td>{{"returnsUK.totaltivccredittxt" | cxTranslate}}</td>
                                    <td class="returnparent">
                                      <input type="text" class="totalReturn form-control blanktotalvalue" [value]="computeCreditTotalDoses(shipData.groupedProducts[productName], productName, shipData)" readonly="">
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <div class="clearboth"></div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                    <table class="Return_Credit_Doses Returntotalbox_ErrorMsg">
                      <tbody>
                        <tr class="agreed_Sor_Row">
                          <td colspan="2">
                            <div>Based on your agreed sale or return percentage.</div>
                          </td>
                        </tr>
                        <tr class="error_Msg_Container">
                          <!-- Left column-->
                          @for (productName of getGroupedProductKeys(shipData.groupedProducts); track productName) {
                            @if (productName === 'aQIV' || productName === 'aTIV') {
                              <td class="batcherror leftcol aqiv_Error_Row" colspan="2" >
                                @if (shipData?.aqiverrorsor || shipData?.aqiverrorquantity) {
                                  @if (shipData.aqiverrorsor) {
                                    <div><span class="glyphiconsign"></span>&nbsp;{{"returnsUK.maxdoseerror" | cxTranslate}}</div>
                                  } @else {
                                    @if (shipData.aqiverrorquantity) {
                                      <div><span class="glyphiconsign"></span>&nbsp;{{"returnsUK.maxbatchdoeserror" | cxTranslate}}</div>
                                    }
                                  }
                                }
                              </td>
                            }
                            <!-- Right column: QIVc errors-->
                            @if (productName === 'QIVc' || productName === 'TIVc') {
                              <td class="batcherror rightcol qivc_Error_Row" colspan="2" >
                                @if (shipData?.qivcerrorsor || shipData?.qivcerrorquantity) {
                                  @if (shipData.qivcerrorsor) {
                                    <div><span class="glyphiconsign"></span>&nbsp;{{"returnsUK.maxdoseerror" | cxTranslate}}</div>
                                  } @else {
                                    @if (shipData.qivcerrorquantity) {
                                      <div><span class="glyphiconsign"></span>&nbsp;{{"returnsUK.maxbatchdoeserror" | cxTranslate}}</div>
                                    }
                                  }
                                }
                              </td>
                            }
                          }
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="row blankparent">
                    <div class="col-xs-8 no-padding blankerror" >
                      @if (errorMessages[shipData.locationID]) {
                        <div class="error-message"><i class="fa-solid fa-circle-exclamation"></i>&nbsp;{{ errorMessages[shipData.locationID] }}</div>
                      }
                      @if (shipData.bothproductempty) {
                        <div class="error-message"><i class="fa-solid fa-circle-exclamation"></i>&nbsp;Please click <span class='returnPopupshow errornoreturnlink' (click)="openExistpopup()">here</span> and verify no returns</div>
                      }
                    </div>
                  </div>
                  <div class="newReturn_location">{{"returnsUK.uploaddoclabel" | cxTranslate}}</div>
                  <div class="Returnimagebox marginB25">
                    <div class="leftside_Upload_Documentation">
                      <div class="imageuploadsub">{{"returnsUK.uploadimgmsg" | cxTranslate}}</div>
                      <button class="uploadbtn mappingpop-0" id="uploadbutton-{{shipData.locationID}}" type="button" (click)="openFileUploadModal(shipData.locationID,shipData.qrCodeScannerUrl,shipData.qrToken,shipData.customerToken,returnData.shippingdata.locname)">{{"returnsUK.uploadnviewimgtxt" | cxTranslate}}</button>
                      <span class="uploadedquat"><span class="uploadednum" id="uploadednum-{{shipData.locationID}}">{{ getUploadedImageCount(shipData.locationID) }}</span>
                    {{"returnsUK.imguploadtxt" | cxTranslate}}</span>
                    <div class="imageformattext">{{"returnsUK.imgsizeerror" | cxTranslate}}</div>
                    <div class="Returncheckbox">
                      <label class="Retunrcheck-button"> <input type="checkbox" class="Return_check dynimagecheck" id="imagecheck0-{{shipData.locationID}}" name="imagecheck0-{{shipData.locationID}}" [(ngModel)]="checkboxStates[shipData.locationID]" [checked] ="checkboxStates[shipData.locationID]" [disabled]="getUploadedImageCount(shipData.locationID) > 0" (change)="onCheckboxChangeimg(shipData.locationID)"> <span class="Retuncheck-button__control"></span> <label class="Returnlabeltext">{{"returnsUK.imgnotuploadmsg" | cxTranslate}}</label>
                    </label>
                    @if (checkboxErrorMessages[shipData.locationID] && !checkboxStates[shipData.locationID] && getUploadedImageCount(shipData.locationID)== 0) {
                      <label id="imagecheck0-error" class="error help-block" for="imagecheck0-{{shipData.locationID}}">
                        <i class="fa-solid fa-circle-exclamation"></i>&nbsp;{{ checkboxErrorMessages[shipData.locationID] }}
                      </label>
                    }
                    <div class="clearboth"></div>
                  </div>
                </div>
                <!-- <div class="rightside">
                <div class="newReturn_location">{{"returnsUK.exampeimgtxt" | cxTranslate}}</div>
                <div class="Returnimageexample">
                  <div class="leftsideexm">
                    <img src="assets/images/ReturnImageExample3.png" class="img-fluid">
                  </div>
                  <div class="rightsideexm">
                    <img src="assets/images/ReturnImageExample2.jpg" class="img-fluid">
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        }
      </div>
    }
  </div>
  <div class="btmsec">
    <div class="completetext">{{"returnsUK.completereturnreq" | cxTranslate}}</div>
    <div class="row">
      <div class="Returnsubmitbox col-md-7 leftside">
        <label class="Retunrcheck-button"> <input type="checkbox" class="Return_check" id="finalcheck" name="finalcheck" [(ngModel)]="checkboxChecked" (change)="onCheckboxChange()"> <span class="Retuncheck-button__control"></span> <label class="Returnlabeltext">{{"returnsUK.returnreqmsg" | cxTranslate}}</label>
      </label>
      @if (checkboxErrorMessage) {
        <label id="finalcheck-error" class="error help-block" for="finalcheck">
          <i class="fa-solid fa-circle-exclamation"></i>&nbsp;{{ checkboxErrorMessage }}
        </label>
      }
      <div class="clearboth"></div>
    </div>
    <div class="submitbtnsection col-md-5 no-padding-right">
      <a class="prodReturn_exitBtn returnPopupshow" (click)="openExistpopup()">{{"returnsUK.exitlabel" | cxTranslate}}</a>
      <button class="productsumbitbtn" id="productSubmit" type="button" (click)="processAndSendPayloads()">{{"returnsUK.submitreturnreq" | cxTranslate}}</button>
    </div>
  </div>
</div>
<div>
</div>
</div>
}
@if (showFeedback) {
  <section class="col-xs-12 col-md-12 UkCreateReturn" id="ReturnThank">
    <div class="Returnthank_box">
      <div class="thankReturn_head">{{"returnsUK.thankyoumsg" | cxTranslate}}</div>
      <div class="thankreturn_text">{{"returnsUK.emailconfirmsg" | cxTranslate}}</div>
      <div class="returnFeedbackBox">
        <div class="feedbackheader">How was your experience with the return request process?</div>
        <div style="font-family: Verdana; font-size: 12px; overflow:hidden;">
          <table cellpadding="0" cellspacing="0" border="0" class="feedbacktable no-padding">
            <tbody><tr>
              <td class="feedbackbox">
                <a href="https://app.customerthermometer.com/?template=log_feedback&amp;hash=7bc5e051&amp;embed_data=dGVtcGVyYXR1cmVfaWQ9NCZ0aGVybW9tZXRlcl9pZD0xNzk2NDUmbnBzX3JhdGluZz0=&amp;e=&amp;f=&amp;l=&amp;c=&amp;c1=&amp;c2=&amp;c3=&amp;c4=&amp;c5=&amp;c6=&amp;c7=&amp;c8=&amp;c9=&amp;c10=" target="_blank" class="returnPopupshow">
                  <img style="border: none;" src="https://app.customerthermometer.com/sites/app/images/icon_sets/icon_set_3s/red.png" alt="Red Light" title="Red Light" class="_temp">
                </a>
              </td>
              <td class="feedbackbox">
                <a href="https://app.customerthermometer.com/?template=log_feedback&amp;hash=7be5181c&amp;embed_data=dGVtcGVyYXR1cmVfaWQ9MyZ0aGVybW9tZXRlcl9pZD0xNzk2NDUmbnBzX3JhdGluZz0=&amp;e=&amp;f=&amp;l=&amp;c=&amp;c1=&amp;c2=&amp;c3=&amp;c4=&amp;c5=&amp;c6=&amp;c7=&amp;c8=&amp;c9=&amp;c10=" target="_blank" class="returnPopupshow">
                  <img style="border: none;" src="https://app.customerthermometer.com/sites/app/images/icon_sets/icon_set_3s/amber.png" alt="Yellow Light" title="Yellow Light" class="_temp">
                </a>
              </td>
              <td class="feedbackbox">
                <a href="https://app.customerthermometer.com/?template=log_feedback&amp;hash=32ff96cc&amp;embed_data=dGVtcGVyYXR1cmVfaWQ9MiZ0aGVybW9tZXRlcl9pZD0xNzk2NDUmbnBzX3JhdGluZz0=&amp;e=&amp;f=&amp;l=&amp;c=&amp;c1=&amp;c2=&amp;c3=&amp;c4=&amp;c5=&amp;c6=&amp;c7=&amp;c8=&amp;c9=&amp;c10=" target="_blank" class="returnPopupshow">
                  <img style="border: none;" src="https://app.customerthermometer.com/sites/app/images/icon_sets/icon_set_3s/green.png" alt="Green Light" title="Green Light" class="_temp">
                </a>
              </td>
              <td class="feedbackbox">
                <a href="https://app.customerthermometer.com/?template=log_feedback&amp;hash=3a1f4098&amp;embed_data=dGVtcGVyYXR1cmVfaWQ9MSZ0aGVybW9tZXRlcl9pZD0xNzk2NDUmbnBzX3JhdGluZz0=&amp;e=&amp;f=&amp;l=&amp;c=&amp;c1=&amp;c2=&amp;c3=&amp;c4=&amp;c5=&amp;c6=&amp;c7=&amp;c8=&amp;c9=&amp;c10=" target="_blank" class="returnPopupshow">
                  <img style="border: none;" src="https://app.customerthermometer.com/sites/app/images/icon_sets/icon_set_3s/gold.png" alt="Gold Star" title="Gold Star" class="_temp">
                </a>
              </td>
            </tr>
          </tbody></table>
        </div>
      </div>
      <a class="nopopshow returnPopupshow" (click)="goToreturn()">
        <div class="Returnbutton">View Returns</div>
      </a>
    </div>
    <!--  <app-custom-returns-thankyouvideo></app-custom-returns-thankyouvideo>
    <app-custom-returns-thankyoumaterials></app-custom-returns-thankyoumaterials>
    <app-custom-picture-resources></app-custom-picture-resources> -->
  </section>
}
</div>
}

